import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { BrowserRouter } from "react-router-dom";
import { FormDataProvider } from "./context/FormContext";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { AuthProvider } from "./context/AuthContext";
import { AuthContextProvider } from "./Supabase/context/AuthContext";
// import 'bootstrap/dist/css/bootstrap.min.css';
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
const AUTH_AUDIENCE = process.env.REACT_APP_AUTH_AUDIENCE;

const customTheme = extendTheme({
  initialColorMode: "dark",
  semanticTokens: {
    colors: {
      text: {
        default: "red.700",
        _dark: "red.200",
      },
    },
  },
  components: {
    Tabs: {
      variants: {
        enclosed: {
          tab: {
            _selected: {
              bg: "white",
              color: "black",
            },
            _hover: {
              bg: "gray.200",
            },
          },
          tablist: {
            borderBottom: "1px solid",
            borderColor: "blue.500",
          },
          tabpanel: {
            p: 4,
          },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <FormDataProvider>
    <Provider store={store}>
      {/* <AuthProvider> */}
      <AuthContextProvider>
        <BrowserRouter>
          <ChakraProvider theme={customTheme}>
            <App />
          </ChakraProvider>
        </BrowserRouter>
      </AuthContextProvider>
      {/* </AuthProvider> */}
    </Provider>
  </FormDataProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
